import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from 'recharts';

const EMPTY_TEXT = 'No activity in this range';

const STATUS_COLORS = {
  Active: '#16a34a',
  Cancelled: '#dc2626',
  Expired: '#a16207',
  Other: '#6b7280',
};

const TooltipContent = ({ active, payload }) => {
  if (!active || !payload || payload.length === 0) return null;
  const slice = payload[0]?.payload;
  if (!slice) return null;
  return (
    <div className="wa-chart-tooltip">
      <div className="wa-chart-tooltip-title">{slice.status}</div>
      <div className="wa-chart-tooltip-row">
        <span>Count</span>
        <strong>{slice.count}</strong>
      </div>
      <div className="wa-chart-tooltip-row">
        <span>Share</span>
        <strong>{slice.percentage}%</strong>
      </div>
    </div>
  );
};

TooltipContent.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
};

const StatusDonut = ({ data }) => {
  if (!Array.isArray(data) || data.length === 0) {
    return <div className="wa-chart-empty">{EMPTY_TEXT}</div>;
  }

  return (
    <div className="wa-chart" data-testid="status-donut-chart">
      <ResponsiveContainer width="100%" height={260}>
        <PieChart>
          <Pie
            data={data}
            dataKey="count"
            nameKey="status"
            innerRadius={55}
            outerRadius={90}
            paddingAngle={2}
            isAnimationActive={false}
          >
            {data.map((entry) => (
              <Cell key={entry.status} fill={STATUS_COLORS[entry.status] || '#6b7280'} />
            ))}
          </Pie>
          <Tooltip content={<TooltipContent />} />
          <Legend iconType="circle" wrapperStyle={{ fontSize: 12 }} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

StatusDonut.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
      percentage: PropTypes.number,
    })
  ),
};

export default StatusDonut;
